import internal from 'stream'

import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface GetCustomerOrderListInterface {
  partnerCodes?: any
  orderTypes?: any
  fromDate?: any
  toDate?: any
  take?: number
  skip?: number
  SearchKeyword?: string
}

export const useGetCustomerOrderList = () => {
  const mutate = useMutation(
    ({
      partnerCodes,
      orderTypes,
      fromDate,
      toDate,
      take,
      skip,
      SearchKeyword,
    }: GetCustomerOrderListInterface) => {
      return postAPI(`MWDashboard/ListCustomerOrders`, {
        partnerCodes: partnerCodes || [],
        OrderTypes: orderTypes || [],
        fromDate: fromDate || '',
        toDate: toDate || '',
      })
    },
  )

  return mutate
}

export default useGetCustomerOrderList
